import axios from "./AxiosService";

export default class PrintPreferenceService {
  GetPrintPreference(membershipNumber) {
    return axios
      .get(
        "PrintPreference",
        {
          params: { membershipNumber: membershipNumber }
        },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
      .then(response => {
        return response.data;
      });
  }

  SetPrintPreference(membershipNumber, documentPreference) {
    const printPreferenceModelForApi = {
      MembershipNumber: membershipNumber,
      PrintPreference: documentPreference
    };
    return axios
      .post("PrintPreference", printPreferenceModelForApi, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        return response.data;
      });
  }
}
